export default {
    activateuser: {
        headerLabel: '用户入门',
        accountActivation: '账户激活',
        step1: {
            header: '欢迎来到我们的平台！',
            subHeader: '选择您想要连接到账户的方式',
            description: '为简化登录过程，我们建议您至少将帐户连接到以下服务之一。',
            OR: '或',
            emailAndPassword: '使用您自己的邮箱',
        },
        step2: {
            header: '使用邮箱和密码',
            description:
                '这是将与您账户关联的主要邮箱。﻿我们建议您不要使用大学地址注册的邮箱，以便在毕业后继续访问您的数据。﻿您可以在账户设置中轻而易举地管理我们给您发送的邮件。',
            invalidEmail: '提供的邮箱不是有效邮箱。',
            passwordsNotMatch: '密码必须一致',
            passwordDescription01:
                '为了确保您的账户安全，您需要设置新的密码。﻿请按照以下要求设置密码：',
            passwordDescription02: '最少8个字符',
            passwordDescription03: '至少包含一个小写字符（a-z）',
            passwordDescription04: '至少包含一个大写字符（A-Z）',
            passwordDescription05: '至少包含一个数字或特殊符号（0-9, !#$ etc）',
            passwordDescription06: '至少包含6个不重复字符',
            repeatPassword: '再次输入密码',
        },
        step3: {
            header: '激活用户',
            loadingHints: {
                '0': '正在加载用户数据',
                '1': '正在进行准备',
                '2': '新的可能性近在眼前',
                '3': '即将完成！',
            },
            successHeader: '您的账户现已准备就绪！',
            successSubheader: '您现在可以访问专属功能了！',
            errorHeader: '无法激活账户',
            ifWrongContact: '如果您认为出现错误，请联系支持',
            contactForHelp: '联系我们寻求帮助',
            goBack: '返回',
        },
    },
    assessments: {
        general: {
            checkMyProgress: '检查我的进度',
            getStarted: '现在开始！',
            getToKnowYourself: '了解自己',
            getToKnowYourselfBold: '了解<strong>自己</strong>',
            getToKnowYourFuture: '了解您的未来',
            getToKnowYourFutureBold: '了解您的<strong>未来</strong>',
            openAssessments: '开放测评',
            openAssessment: '开放测评',
            unlock: '解锁测试',
            testYourself: '自我测试',
            takeTheFreeTests: '参加免费测试',
            youOwnThisProduct: '您已拥有此产品',
            startTest: '开始测试',
            startTests: '开始测试',
            continue: '继续',
            showReport: '显示报告',
            showYourReports: '显示您的报告',
            showYourReport: '显示您的报告',
            continueFreeTests: '继续免费测试',
            continueTheTest: '继续测试',
            estimatedTime: '~ {min}分钟',
        },
        landing: {
            section1: {
                title: '自我测试',
                description01: '欢迎来到测评中心——您的职业生涯将从这里开始。',
                description02:
                    '您可在这里参加<strong>Aon测评</strong>，这是针对全球人员招聘的测试，主要是核实您的能力以及对未来职业的准备情况。',
                freemium: {
                    description: '参加这些测试来衡量您的优势，并获得高效的技能报告。',
                    price: '免费',
                    numTests: '3次测试',
                    timeEstimated: '约﻿27分钟',
                },
                premium: {
                    description:
                        '真正的<strong>货真价实</strong>。﻿参加该三合一测试，找到最适合您应该追求的职业路径，并获得完整的求职者报告。',
                    numTests: '三合一测试',
                    timeEstimated: '约﻿60分钟',
                    sampleReport: '↓下载示例报告',
                    candidateReport: '求职者报告',
                    candidateReportDescription:
                        '在完成这些测试后，您将立即获得完整的求职者报告。报告将对您的结果进行全面概括，其中包括您的个人技能提升技巧，您需要具体留意哪些技能，您最适合从哪些机会入手，下一步该怎样做等。',
                },
            },
            section2: {
                title: '这些测试将如何助您获得录用？',
                t1: '您将了解自己的<strong>技能</strong>',
                t2: '您将意识到自己的<strong>潜力</strong>',
                t3: '您将拥有清晰的<strong>职业路径</strong>',
                t4: '您将增强自己的<strong>自信心</strong>',
            },
            section3: {
                title: '了解您的个人优势和职业机会，推动自己的发展和职业进步。',
            },
            section4: {
                title: '今天就超越您的竞争对手',
                description:
                    '通过完成德勤、西门子、汉堡王、沃达丰或宝洁等公司全球招聘人员使用的测评。',
            },
            section5: {
                title: '常见问题解答',
                thisPage: '本页',
                question01: {
                    q: '怡安测评是什么？',
                    a:
                        '怡安人才测评是在全球范围内广受认可的测试，可以帮助世界各地的公司发现最佳工作人选。﻿在人才测评的帮助下，招聘人员可以超越简历、学校成绩、大学证书和文凭的局限，来了解求职者与岗位是否匹配。\n <br><br>\n 这些解决方案通常<strong>仅限招聘人员</strong>使用﻿——您将在此获得<strong>独家</strong>﻿机会在面试前进行练习，并获得成绩。﻿大多数求职者都没有这样的机会，所以，请好好把握！',
                },
                question02: {
                    q: '我需要付费才能进行这些测评吗？',
                    a:
                        '您可以免费参加其中4个测试 –﻿<i>工作相关行为</i>、<i>数字推力</i>、 <i>演绎逻辑思维</i>和<i>归纳逻辑推理</i>。﻿这些测试旨在衡量您的技能和天赋，是发现您的优势和弱势的绝佳方式。\n\n <br><br>但是，如果您想全面了解自己的职业倾向，获得有关最适合您的职业路径的专业见解，向未来的成功迈出一大步，您也可以参加三合一测试，获得全面求职者报告，价格为79欧元。﻿<br><br>若要获得更多访问权限，只需<a href={premiumLink}>点击这里</a>﻿使用银行卡付款 –﻿我们使用安全的付款方式。\n',
                },
                question03: {
                    q: '我为何要参加这些测试？',
                    a:
                        '\n世界各地的招聘人员在求职者遴选过程中都会使用怡安测评。﻿提前完成测评并向招聘人员展示准备好的报告，您将获得让他们眼前一亮的大好机会。﻿为什么这么说呢？﻿\n <br><br>\n首先，您已做好准备并完成了部分招聘流程，这将使你从其他应聘者当中脱颖而出。\n <br><br>\n其次，﻿您在应聘时可以有清晰的思路。﻿您清楚了解自己的优势以及未来将面对什么情况——这将确保您拥有即时动力并能适当增强自信！﻿招聘人员能清楚看出这一点。',
                },
                question04: {
                    q: '我怎样为这些测试做准备？',
                    a:
                        '您可以在<a href={link} target="_blank">此页面</a>阅读所有相关技术要求，并了解如何为测评做好准备。﻿您还能找到助您决胜的材料',
                },
                question05: {
                    q: '我还能在哪里找到这些测评？',
                    a:
                        '通常，招聘人员可能要求您完成这些测试——除此之外，您在其他任何地方都找不到这些测试。﻿这是您的专属机会，通过练习，您可以更了解自己以及自己的未来职业。',
                },
                question06: {
                    q: '我可以参加多少次测试？',
                    a:
                        '每个测试只有一次参与机会。﻿不能重新测试！﻿为充分利用这个机会，请确保您在舒适的条件下参加测试。﻿在测试前，您可以通过观看教学视频、做练习来熟悉测试。',
                },
                question07: {
                    q: '这些测试用什么语言进行？',
                    a:
                        '\n这些测试的默认语言是英语，但每个测试都有多种语言可供选择。﻿您可以在参加测试前查看可选的语言，并选择最适合自己的语言。﻿\n',
                },
                question08: {
                    q: '一旦我支付了费用，扩展测试是否有到期日期？',
                    a:
                        '没有！﻿在您的付款被接受后，您可以随时参加扩展测试。﻿请慢慢准备，在最适合您的时间开始进行测评。',
                },
            },
        },
        center: {
            banner: {
                title: '检查您的进展',
                subtitle: '下面是您在职业测评中的进展概况',
                moreInfo: '更多信息',
                yourProgress: '您的进展',
                quote: '设定目标是将无形的愿景转化为有形的成果的第一步。',
            },
            list: {
                timeEstimated: '约﻿{minutes}分',
                freemium: {
                    intro:
                        '\n这是您个人发展历程的第一步！﻿<br />\n参加这些测试来衡量您的优势，并获得高效的报告以了解您的\n 技能。\n',
                },
                premium: {
                    intro:
                        '\n真正的货真价实。<br />\n参加这些测试，找出您应该追求的职业路径，并获得\n全面的<strong>求职者报告</strong>。\n',
                    description:
                        '\n您的<strong>求职者报告</strong>﻿将对您的结果进行全面\n概括，包括提供一些<strong>技巧</strong>﻿来帮您提升\n个人技能，指出哪些<strong>技能</strong>﻿是您需要留意的、您\n最适合从哪些<strong>机会</strong>﻿入手、\n <strong>下一步</strong>该怎么做等。\n',
                },
            },
            instruments: {
                '344': {
                    name: '演绎逻辑思维',
                    description:
                        '了解您有多擅长运用知识和应用规则--﻿该测试衡量您分析和解决问题的能力。',
                    estimatedTime: '9',
                },
                '383': {
                    name: '归纳逻辑推理',
                    description:
                        '您能够在多大程度上识别规则和相互关系？﻿查看该测试，衡量您分析和解决问题的能力。',
                    estimatedTime: '9',
                },
                '390': {
                    name: '工作相关行为',
                    description:
                        '您有什么类型的员工性格特征？﻿参加本测试，发现您在工作方面的性格特征。',
                    estimatedTime: '30',
                },
                '721': {
                    name: '数字推理',
                    description:
                        '您处理数字的能力有多强？﻿本测试衡量您对数字信息的理解以及得出合理结论的能力。',
                    estimatedTime: '9',
                },
                '5392': {
                    name: '工作记忆',
                    description:
                        '您能在多大程度上保持专注？﻿本测试衡量在分散注意力的环境中处理和记忆信息的能力。',
                    estimatedTime: '15',
                },
                '82013': {
                    name: '弹性测试',
                    description: '您有什么兴趣？﻿本问卷将有助于确定您可能想要追求的职业路径。',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: '开始怡安测评',
            consent:
                '我明白怡安公司对我与此测评有关的数据负责，并同意其条款和条件。\n我也同意Highered可以将我的名字转给怡安公司，以生成我的报告。',
            startTest: '开始测试',
            consentErrorTitle: '同意错误',
            consentErrorMessage: '在您提交同意时出现问题。﻿你确认自己的邮件了吗？',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats": {
        '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair': {
            " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire": {
                '"':
                    '\n Persӧnliche Vermittler auf der ganzen Welt verwenden AON Bewertungstests in ihrem Kandidatenauswahlprozess. Indem Sie sie im Voraus ausfüllen und ihnen fertige Berichte vorlegen, erhalten Sie eine großartige Gelegenheit, die Arbeitnehemer wirklich in Erstaunen zu versetzen. Wie? \n <br><br>\n Erstens – Sie sind vorbereitet, da ein Teil des Rekrutierungsprozesses bereits abgeschlossen ist, wodurch Sie anderen Kandidaten sofort einen Schritt voraus sind.\n <br><br>\n Zweitens – Sie gehen auf Ihre Rekrutierung mit klarem Verstand. Sie kennen Ihre Stärken und wissen, was die Zukunft für Sie bereithält – sofortige Motivation und ein richtiger Selbstvertrauensschub garantiert! Das können Recruiter feststellen.',
            },
        },
    },
    calendar: {
        header: '日历',
        myCalendar: '我的日历',
        noCalendar: '您的就业服务尚未激活日历功能。',
        goBackBtn: '返回',
        calendarNotReady: '“我的日历”﻿功能尚未准备就绪。﻿即将推出！',
        noUpcomingAppointments: '您没有即将开始的预约。',
        appointmentMissing: '预约未激活',
        appointmentNotActive: '很抱歉，您试图查看不存在或未激活的预约。',
        appointmentNotHavingAvailability: '很抱歉，无法为您预约当前时段。﻿请稍后再试。',
        appointmentMissingRules: '无法进行预约',
        needToCompleteProfile: '完成您的个人资料',
        noUpcomingAppointmentsPleaseBook: '进行预约以解锁您的日历。',
        bookAppointment: '进行预约',
        bookAnotherAppointment: '进行预约',
        attendedAppointments: '您已参加过的预约',
        aboutAppointments: {
            header: '关于预约',
            button: '关于',
            block1: { header: '预约是什么？' },
            block2: { header: '我可以与谁联系获得更多详细信息？' },
        },
        bookAnAppointment: '进行预约',
        backToCalendarBtn: '返回日历',
        backToBookingBtn: '返回预约列表',
        firstAvailable: '第一个可用',
        loadingAppointment: '加载中……',
        bookModal: {
            title: '确认预订',
            with: '与',
            confirm: '确认',
            continue: '继续',
            cancel: '关闭',
            first: {
                title: '这是您的第一次预约',
                description: '为确保您收到活动邀请，请确保您能够通过此邮箱账户访问个人日历',
                ok: '确定',
                wrongEmail: '错误的邮箱？',
            },
            changeEmail: {
                title: '选择您的日历邮箱',
                inputPlaceholder: '输入邮箱...',
                ok: '确定',
                back: '使用默认值',
            },
            unknownErrorHeader: '尝试预订时发生错误',
            unknownErrorBody: '请尝试预订其他时间，如果这不起作用，请联系支持人员。',
            confirmationHeader: '您已预约成功！',
            bookedTheFollowing: '详情：',
            emailWillBeSent: '您将收到邮件',
            withConfirmation: '要求您确认出席。',
        },
        dateDetailsModal: { title: '预约时间' },
        completedYourProfile: '您需要完成个人资料才能访问日历系统',
        toMyProfile: '编辑我的个人资料',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name}想要查看您的个人资料',
            content: '您想与此人共享您的个人资料吗？',
            share: '分享个人资料',
            reject: '拒绝',
        },
    },
    companyDetail: {
        locations: {
            header: '位置',
            viewAll: '查看全部',
            noLocations: '没有位置',
            allLocations: '所有位置',
        },
        jobModule: {
            header: '最高职位',
            viewAllJobs: '查看{companyName}的所有工作',
            noPositions: '{companyName}目前在Highered没有任何空缺职位。',
            defaultLabel: '空缺职位',
        },
        videos: {
            header: '视频',
            noVideos: '没有视频',
            noMoreVideos: '没有更多视频',
            moreVideosFrom: '更多来自{companyName}的视频',
        },
        articles: {
            header: '文章',
            noArticles: '没有文章',
            noMoreArticles: '没有更多文章',
            moreArticlesFrom: '更多来自{companyName}的文章',
        },
    },
    components: {
        builders: {
            searchable: { create: '创建' },
            yearMonthPicker: { defaultSelect: '选择一个月份' },
            localeDropdown: { languages: { en: '英语', cn: '中文', fr: '法语' } },
        },
        miscellaneous: {
            verifyModule: {
                title: '验证您的学校邮箱',
                description:
                    '这是一个快速过程，让您可以访问\n专属功能，如独特的职位发布、技能\n测试以及职业资源。',
                verificationPending: '等待验证',
                weHaveSentAnEmail:
                    '我们已向\n <strong>{studentEmail}</strong>发送了一封邮件﻿请\n您进行身份验证。﻿请务必\n查看您的垃圾邮件文件夹，因为许多学校对收到的邮件有\n相当严格的要求。',
                verifyMe: '对我进行验证',
                resendVerifyEmail: '重新发送验证邮件',
                cancelVerification: '取消验证',
                emailSent: '邮件已发送',
                emailSentMessage:
                    '邮件已成功发送。﻿如果您未收到邮件，请通过support@highered.global联系我们。',
                resendErrorTitle: '邮件发送过程中出现错误',
                resendErrorMessage:
                    '无法重新发送验证邮件。﻿请通过support@highered.global联系我们。',
                verificationCancelledTitle: '验证已取消',
                verificationCancelledMessage: '验证已成功取消。',
                cancelErrorTitle: '取消时出现错误',
                cancelErrorMessage: '无法取消验证。﻿请通过support@highered.global联系我们。',
            },
            verifyModuleDialog: {
                title: '验证您的学校邮箱',
                university: '学术机构',
                studentEmail: '您的学术邮箱地址',
                studentEmailPlaceholder: '学术邮箱',
                message: '留言',
                verify: '验证',
                sendRequest: '发送请求',
                verificationInProcess: '正在进行验证',
                emailHasBeenSentTo:
                    '已向<strong>{email}</strong>发送邮件。﻿请按照此处说明验证您与<strong>{schoolName}</strong>的连接',
                verificationRequestSentNonAcademic:
                    '<strong>{schoolName}</strong>的就业服务﻿需要验证您的连接。﻿当发生这种情况时，您会收到邮件通知。',
                ifNoEmailRecieved: '如果您尚未收到验证邮件，请联系我们。',
                contactHelp: '联系我们寻求帮助',
                doNotHaveAcademicEmail: '我没有学术邮箱地址',
                doubleCheckEmail: '请仔细检查该邮箱地址是否正确，并检查您是否有邮箱访问权限。',
                haveAcademicEmail: '我有学术邮箱地址',
                noAcademicEmailInfo:
                    '如果您不使用学术邮箱地址，那么您的请求需要由就业服务人员进行手动批准。﻿您必须提供一条短消息验证自己的身份。',
                alreadyVerifiedInfo: '您在这所学校已通过验证。',
            },
        },
        navigation: {
            navigation: {
                myPage: '我的页面',
                jobs: '工作',
                companies: '公司',
                resources: '大师班',
                assessments: '测评',
                countryGuides: '国家指南',
                goToHaigui: '中国的工作',
                signIn: '登录/注册',
                vfairs: '虚拟活动',
                events: '活动',
                newFeature: '新功能！',
            },
            profileNavigation: { signOut: '退出' },
            sidebar: {
                myPage: '我的页面',
                myProfile: '我的个人资料',
                findJobs: '查找工作',
                findCompanies: '查找公司',
                resources: '大师班',
                assessments: '测评',
                countryGuides: '国家指南',
                goToHaigui: '中国的工作',
                virtualFairs: '虚拟活动',
                signIn: '登录/注册',
                logOut: '注销',
            },
            backToCalendar: '返回日历',
            allBooths: '所有展位',
            home: '主页',
        },
        smart: {
            companyModule: {
                followJob: '添加到收藏夹',
                followCompany: '关注公司',
                unFollowJob: '从收藏夹中删除',
                unFollowCompany: '取消关注该公司',
                favoritedTitle: '保存到收藏夹',
                favoritedMessage: '该职位已被保存到您的收藏夹。﻿在我的页面查找您最喜欢的职位。',
                unfavoritedTitle: '已从收藏夹中删除',
                unfavoritedMessage: '该职位已从您的收藏夹中删除',
                favoriteErrorTitle: '出现问题',
                favoriteErrorMessage: '无法收藏此职位',
                showAllCompanies: '显示所有公司',
                showOnlyCompaniesLiveOnChat: '仅显示在线聊天的公司',
            },
            profileModule: {
                profileCompletion: '个人资料填写',
                profileCompletionEncouragement:
                    '完成个人资料的最后{percentageLeft}，向雇主展示您自己',
                gotoProfilePage: '更新个人资料',
                profileCompleted: '个人资料已完成',
                profileCompletedWhatsNext:
                    '您知道多数雇主会在招聘过程中使用在线测评吗？﻿立即练习，并深入了解您的优势和弱势。',
                gotoTestsPage: '前往测评中心',
                authIndication: {
                    title: '查找您梦寐以求的工作',
                    description:
                        '您是否希望访问您学校特有的职位，以及能够为您求职赋能的测试？﻿立刻使用谷歌、领英或Facebook轻松创建用户。',
                    action: '让我们开始吧',
                },
                toProfileHint: '前往我的个人资料',
                toProfileUncompletedHint:
                    '您的个人资料没有100%完成。﻿请继续完成个人资料，以最大程度地提升您的就业能力。',
                profileActions: {
                    addFirstName: '添加名字',
                    addLastName: '添加姓氏',
                    addNationality: '添加国际',
                    addPhoneNumber: '添加您的电话号码',
                    addLanguage: '添加语言',
                    addEducation: '添加教育情况',
                    addEmail: '添加您的邮箱',
                    addGender: '添加您的性别',
                },
            },
            featuredCompanies: { label: '特色公司' },
            featuredPositions: { label: '特色职位' },
            featuredResource: {
                header: '加入虚拟会议',
                cta: '现在观看！',
                wechatSignupHeader: '关注Highered微信公众号，获取更新',
                wechatSignupCta: '马上扫码！',
            },
        },
    },
    '"': '지금 코드를 스캔하십시오!',
    cts: {
        filterNames: {
            employment_types: '工作性质',
            education_level: '学位',
            job_category: '领域',
            address: '位置',
            sector: '部门',
            exclude_school_id: '排除',
            languages: '语言',
        },
        excludeSchoolIds: {
            '-1': '共享的帖子',
            unknownSchoolId: 'EFMD学校合作伙伴',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: '学士',
            MASTERS_OR_EQUIVALENT: '硕士',
            DOCTORAL_OR_EQUIVALENT: '博士',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: '全职',
            INTERN: '实习',
            TEMPORARY: '兼职',
            PART_TIME: '兼职',
        },
        startDate: '开始',
        educationFields: {
            ACCOUNTING_AND_FINANCE: '会计与金融',
            ADMINISTRATIVE_AND_OFFICE: '行政与办公室工作',
            ADVERTISING_AND_MARKETING: '广告及营销',
            ART_FASHION_AND_DESIGN: '艺术、时尚与设计',
            BUSINESS_OPERATIONS: '商业运作',
            COMPUTER_AND_IT: '计算机与IT',
            CUSTOMER_SERVICE: '客户服务',
            EDUCATION: '教育',
            HEALTHCARE: '医疗保健',
            HUMAN_RESOURCES: '人力资源',
            INSTALLATION_MAINTENANCE_AND_REPAIR: '安装维护及维修',
            LEGAL: '法律',
            MANAGEMENT: '管理',
            MANUFACTURING_AND_WAREHOUSE: '制造和仓库',
            MEDIA_COMMUNICATIONS_AND_WRITING: '媒体传播与写作',
            OIL_GAS_AND_MINING: '能源',
            PROTECTIVE_SERVICES: '安保服务',
            REAL_ESTATE: '房地产',
            SALES_AND_RETAIL: '销售与零售',
            SCIENCE_AND_ENGINEERING: '科学与工程',
            SOCIAL_SERVICES_AND_NON_PROFIT: '社会服务和非营利组织',
            TRANSPORTATION_AND_LOGISTICS: '运输与物流',
        },
        sectors: {
            Consulting: '咨询',
            'Consumer Goods': '消费品',
            'Financial Services / Banking': '金融服务/银行业务',
            'Goverment / Public Administration / Non Profit': '政府/公共管理/非盈利',
            'International Trade & Development': '国际贸易与﻿发展',
            Manufacturing: '制造业',
            'Media / Entertainment': '媒体/娱乐',
            'Petroleum / Energy': '石油/能源',
            'Pharma / Healthcare / Biotech': '制药/医疗保健/生物技术',
            'Real Estate / Construction / Infrastructure': '房地产/建筑/基础设施',
            'Technology (IT) / Telecom': '技术（IT）/电信',
            'Transportations & Logistics': '运输与﻿物流',
            Other: '其他',
        },
        countries: {
            'China (Hong Kong SAR)': '香港',
            'Costa Rica': '哥斯达黎加',
            'Europe & Sub-Saharan Africa': '欧洲和﻿撒哈拉以南非洲',
            'Hong Kong': '香港',
            'Korea, South': '韩国',
            'New Zealand': '新西兰',
            'Papua-Ny Guinea': '巴布亚新几内亚',
            'Puerto Rico': '波多黎各',
            'Saudi Arabia': '沙特阿拉伯',
            'South Africa': '南非',
            'South Korea': '韩国',
            'Sri Lanka': '斯里兰卡',
            'Taiwan (Province of China)': '台湾',
            'The Seychell Islands': '塞舌尔',
            'United Arab Emirates': '阿拉伯联合酋长国',
            'United Kingdom': '英国',
            'Ivory Coast': '象牙海岸',
            Afghanistan: '阿富汗',
            Algeria: '阿尔及利亚',
            Angola: '安哥拉',
            Argentina: '阿根廷',
            Armenia: '阿美尼亚',
            Australia: '澳大利亚',
            Austria: '奥地利',
            Azerbaijan: '阿塞拜疆',
            Bahamas: '巴哈马',
            Bahrain: '巴林',
            Bangladesh: '孟加拉国',
            Belarus: '白俄罗斯',
            Belgium: '比利时',
            Botswana: '博茨瓦纳',
            Brazil: '巴西',
            Bulgaria: '保加利亚',
            Cambodia: '柬埔寨',
            Canada: '加拿大',
            Chile: '智利',
            China: '中国',
            Colombia: '哥伦比亚',
            Congo: '刚果',
            Croatia: '克罗地亚',
            Cyprus: '塞浦路斯',
            Czechia: '捷克',
            Denmark: '丹麦',
            Ecuador: '厄瓜多尔',
            Egypt: '埃及',
            Estonia: '爱沙尼亚',
            Ethiopia: '埃塞俄比亚',
            Fiji: '斐济',
            Finland: '芬兰',
            France: '法国',
            Germany: '德国',
            Ghana: '加纳',
            Greece: '希腊',
            Guernsey: '根西岛',
            Hungary: '匈牙利',
            Iceland: '冰岛',
            India: '印度',
            Indonesia: '印度尼西亚',
            Iraq: '伊拉克',
            Ireland: '爱尔兰',
            Israel: '以色列',
            Italy: '意大利',
            Japan: '日本',
            Jersey: '泽西岛',
            Jordan: '约旦',
            Kazakhstan: '哈萨克斯坦',
            Kenya: '肯尼亚',
            Kuwait: '科威特',
            Laos: '老挝',
            Latvia: '拉脱维亚',
            Lebanon: '黎巴嫩',
            Lithuania: '立陶宛',
            Luxembourg: '卢森堡',
            Malaysia: '马来西亚',
            Malta: '马耳他',
            Mauritania: '毛里塔尼亚',
            Mauritius: '毛里求斯',
            Mexico: '墨西哥',
            Mongolia: '蒙古',
            Morocco: '摩洛哥',
            Myanmar: '缅甸',
            Namibia: '纳米比亚',
            Netherlands: '荷兰',
            Nigeria: '尼日利亚',
            Norway: '挪威',
            Oman: '阿曼',
            Pakistan: '巴基斯坦',
            Panama: '巴拿马',
            Paraguay: '巴拉圭',
            Peru: '秘鲁',
            Philippines: '菲律宾',
            Poland: '波兰',
            Portugal: '葡萄牙',
            Qatar: '卡塔尔',
            Romania: '罗马尼亚',
            Russia: '俄罗斯',
            Senegal: '塞内加尔',
            Serbia: '塞尔维亚',
            Singapore: '新加坡',
            Slovakia: '斯洛伐克',
            Slovenia: '斯洛文尼亚',
            Spain: '西班牙',
            Sudan: '苏丹',
            Swaziland: '斯威士兰',
            Sweden: '瑞典',
            Switzerland: '瑞士',
            Syria: '叙利亚',
            Taiwan: '台湾',
            Tanzania: '坦桑尼亚',
            Thailand: '泰国',
            Tonga: '汤加',
            Turkey: '土耳其',
            Ukraina: '乌克兰',
            Ukraine: '乌克兰',
            USA: '美国',
            Uzbekistan: '乌兹别克斯坦',
            Vanuatu: '瓦努阿图',
            Vietnam: '越南',
            Zambia: '赞比亚',
        },
        languages: {
            Aceh: '亚齐',
            Afrikaans: '南非语',
            Albanian: '阿尔巴尼亚语',
            Amharic: '阿姆哈拉语',
            Arabic: '阿拉伯语',
            Arakanese: '阿拉干语',
            Armenian: '亚美尼亚语',
            Azeri: '阿塞拜疆语',
            Badini: 'Badini',
            Basque: '巴斯克语',
            Belarusian: '白俄罗斯语',
            Bengali: '孟加拉语',
            Berber: '柏柏尔语',
            Bosnian: '波斯尼亚语',
            Bulgarian: '保加利亚语',
            Burmese: '缅甸语',
            Cantonese: '粤语',
            Catalan: '加泰罗尼亚语',
            Cebuano: '宿务语',
            Chechen: '车臣语',
            Chin: 'Chin',
            Chinese: '中文',
            Croatian: '克罗地亚语',
            Czech: '捷克语',
            Danish: '丹麦语',
            Dari: '达理语',
            Dutch: '荷兰语',
            English: '英语',
            Estonian: '爱沙尼亚语',
            Faroese: '法罗语',
            Filipino: '菲律宾语',
            Finnish: '芬兰语',
            French: '法语',
            German: '德语',
            Greek: '希腊语',
            Greenlandic: '格陵兰语',
            Hausa: '豪萨语',
            Hebrew: '希伯来语',
            Hindi: '印地语',
            Hungarian: '匈牙利语',
            Icelandic: '冰岛语',
            Indonesian: '印尼语',
            Italian: '意大利语',
            Japanese: '日语',
            Kazakh: '哈萨克语',
            Kinyarwanda: '基尼亚卢旺达语',
            Kirundi: '基隆迪语',
            Korean: '韩语',
            Kurdish: '库尔德语',
            Kurmanji: 'Kurmanji',
            Kven: 'Kven',
            Latin: '拉丁语',
            Latvian: '拉脱维亚语',
            Lingala: '林加拉语',
            Lithuanian: '立陶宛语',
            Macedonian: '马其顿语',
            Malagasy: '马达加斯加语',
            Malaysian: '马来语',
            Mandarin: '普通话',
            Mongolian: '蒙古语',
            Nepali: '尼泊尔语',
            Norwegian: '挪威语',
            Oromo: '奥罗莫语',
            Other: '其他',
            Panjabi: '旁遮普语',
            Pashto: '普什图语',
            Persian: '波斯语',
            Polish: '波兰语',
            Portuguese: '葡萄牙语',
            Punjabi: '旁遮普语',
            Romanes: 'Romanes',
            Romani: '罗姆语',
            Romanian: '罗马尼亚语',
            Russian: '俄语',
            Sami: '萨米语',
            Serbian: '塞尔维亚语',
            Sign_language: '手语',
            Slovak: '斯洛伐克语',
            Slovene: '斯洛文尼亚语',
            Somali: '索马里语',
            Sorani: 'Sorani',
            Spanish: '西班牙语',
            Swahili: '斯瓦希里语',
            Swedish: '瑞典语',
            Tagalog: '他加禄语',
            Tamil: '泰米尔语',
            Thai: '泰语',
            Tigrinya: '提格里尼亚语',
            Turkish: '土耳其语',
            Ukrainian: '乌克兰语',
            Urdu: '乌尔都语',
            Uyghur: '维吾尔语',
            Vietnamese: '越南语',
            Wolof: '沃洛夫语',
        },
    },
    emailverification: {
        headerLabel: '邮箱验证',
        verifyingEmail: '正在验证邮箱',
        emailVerifySuccess: '您的邮箱已通过验证！',
        emailVerifyFailure: '出现问题...﻿请稍后再试或联系支持人员',
        gotoMyPage: '返回我的页面',
    },
    errors: {
        defaultErrorMessage: '发生错误！',
        logInErrorText: {
            invalidCredentials: '错误的用户名或密码',
            inactiveUser:
                '提供邮箱的用户处于非活动状态。﻿请检查您的邮箱，了解账户激活状态或尝试重新设置密码。',
            default: '无法进行身份验证。',
        },
        registerErrorText: {
            passwordTooShort: '密码须至少有8位数。',
            emailAlreadyInUse: '提供的邮箱已被使用。',
            emailTaken:
                '此邮箱已有人使用。﻿如果您使用的是学校邮箱，可能会因为您在平台升级前（在higheredtalent.org）已有用户而发生这种情况。',
            default: '无法创建用户。',
        },
        invalidTokenText: { default: '您的令牌无效或已过期。' },
        passwordErrorText: {
            passwordTooShort: '密码须至少有8位数。',
            requireNonAlphanumeric: '密码必须至少包含一个特殊字符。',
            requireLowerCase: '密码必须至少包含一个小写字母。',
            requireUpperCase: '密码必须至少包含一个大写字母。',
            requireUniqueChars: '密码必须至少包含 6 个不同的字符。',
            default: '无法更改密码',
        },
        recoverErrorText: {
            userNotFound: '用户不存在！﻿请联系支持人员。',
            userAlreadyActive: '用户已激活！\n请尝试登录。',
            emailAlreadyInUse:
                '提供的邮箱已被使用。\n如果您希望继续激活帐户，请尝试使用不同的邮箱或不同的社交登录。﻿否则，请进入主页并登录您的账户。',
            default: '无法激活账户。\n请稍后再试。',
        },
        socialAuthErrorText: {
            errorTitle: '无法使用{provider}登录',
            invalidProviderGoogle:
                '提供邮箱的用户没有与谷歌连接。﻿请尝试使用领英、Facebook等方式，或用邮箱进行登录。',
            invalidProviderFacebook:
                '提供邮箱的用户没有与Facebook连接。﻿请尝试使用谷歌、领英等方式，或用邮箱进行登录。',
            invalidProviderLinkedIn:
                '提供邮箱的用户没有与领英连接。﻿请尝试使用谷歌、Facebook等方式，或用邮箱进行登录。',
            invalidProviderWeChat:
                '提供邮箱的用户没有与微信连接。﻿请尝试使用谷歌、Facebook等方式，或用邮箱进行登录。',
        },
        uniConnErrorText: {
            emailNotAvailable:
                '您所提供的邮箱已被使用。﻿这可能是因为您在平台升级前（在higheredtalent.org）已有用户。﻿请联系支持人员。',
            invalidEmailDomain: '提供的邮箱域名与所提供的大学不匹配。﻿请选择正确的大学。',
            existingConnection: '用户已连接到所提供的大学。',
            default: '无法启动验证。',
        },
        spotlightErrors: {
            userUpdate: { emailAlreadyInUse: '邮箱已在使用中', default: '无法更新' },
        },
    },
    favorites: {
        header: '我的收藏',
        active: '启用',
        expired: '已过期',
        expiresThisMonth: '本月申请截止日期',
        expiresThisWeek: '本周申请截止日期',
        expiresLater: '申请截止日期之后',
        noActiveFavorites: '您没有有效的收藏职位',
        noExpired: '您没有已过期的收藏职位',
    },
    findcompanies: { headerLabel: '查找公司', companyListLabel: '公司' },
    findjobs: {
        header: '查找工作',
        changeFilters: '改变筛选条件',
        recruitmentModule: {
            body: '您是招聘官、就业专家还是仅仅\n对招聘学生人才感兴趣？',
            createJob: '点击这里创建职位发布',
        },
    },
    general: {
        documentTitle: '全球机遇平台',
        email: '邮箱',
        password: '密码',
        confirmPassword: '确认密码',
        loading: '加载中',
        ok: '确定',
        save: '保存',
        add: '添加',
        close: '关闭',
        delete: '删除',
        cancel: '取消',
        done: '完成',
        continue: '继续',
        back: '返回',
        next: '下一步',
        finish: '完成',
        success: '成功',
        error: '出错了',
        description: '描述',
        months: {
            '0': '一月',
            '1': '二月',
            '2': '三月',
            '3': '四月',
            '4': '五月',
            '5': '六月',
            '6': '七月',
            '7': '八月',
            '8': '九月',
            '9': '十月',
            '10': '十一月',
            '11': '十二月',
        },
        days: {
            '0': '周日',
            '1': '周一',
            '2': '周二',
            '3': '周三',
            '4': '周四',
            '5': '周五',
            '6': '周六',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: '正在检查您的待定验证',
                verifySchoolConnection: '验证您的学校连接以访问这些资源',
                logInToAccessMoreFeatures: '数以千计的国际就业机会',
            },
        },
        minutesShort: '分',
        poweredBy: '技术支持',
    },
    gptw: {
        company: { alt: 'GPTW', tooltip: '该公司是获得“最佳职场”﻿认证的公司' },
        posting: {
            label: { alt: 'GPTW', tooltip: '该帖子来自“最佳职场”认证的﻿公司' },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName}是经过认证的最佳职场公司',
                    readMore: '点击阅读更多',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: '申请截止日期',
            location: '位置',
            employmentType: '工作性质',
            languageRequirements: '语言要求',
            workPermitRequirements: '工作许可要求',
            preferredEducationField: '首选教育领域',
            preferredEducationLevel: '首选教育水平',
            jobTags: '标签',
            apply: '立即申请',
            verificationRequired: '您需要先验证学习邮箱才能申请。',
            verificationRequiredHint: '您需要先验证学习邮箱才能申请',
            verificationPending: '您在该学校有一个待定的验证',
            verificationPendingHint: '您在该学校有一个待定的验证',
            startDate: '入职日期',
        },
        invalidJobAd: {
            caption:
                '很抱歉，我们找不到这个职位。﻿如果您认为此处出现错误，请使用以下的聊天框联系支持人员。',
            btn: '查找其他工作',
        },
    },
    mypage: {
        header: '我的页面',
        suggestedPositions: '建议职位',
        favoriteModule: {
            header: '我最喜欢的职位',
            seeAll: '查看全部',
            noFavorites: '您没有有效的收藏职位',
        },
    },
    recoverpassword: {
        createPassword: '设置新的密码',
        newPasswordLabel: '新密码',
        newPasswordPlaceholder: '密码',
        confirmPasswordLabel: '确认密码',
        confirmPasswordPlaceholder: '确认密码',
        resetPasswordButton: '重新设置密码',
        resettingPassword: '正在重新设置密码',
        passwordsNotMatching: '密码不一致。',
    },
    recoveruser: {
        headerLabel: '找回Highered用户',
        accountActivation: '账户激活',
        step1: {
            header: '欢迎来到我们的新平台！',
            subHeader: '选择您想要连接到账户的方式',
            description: '为简化登录过程，我们建议您至少将帐户连接到以下服务之一。',
            OR: '或',
            emailAndPassword: '使用您自己的邮箱',
        },
        step2: {
            header: '使用邮箱和密码',
            description:
                '这是将与您账户关联的主要邮箱。﻿我们建议您不要使用大学地址注册的邮箱，以便在毕业后继续访问您的数据。﻿您可以在账户设置中轻松控制我们向您发送的邮件。',
            invalidEmail: '提供的邮箱不是有效邮箱。',
            passwordsNotMatch: '密码必须一致',
            passwordDescription01:
                '为了确保您的账户安全，您需要设置新的密码。﻿请按照以下要求设置密码：',
            passwordDescription02: '最少8个字符',
            passwordDescription03: '至少包含一个小写字符（a-z）',
            passwordDescription04: '至少包含一个大写字符（A-Z）',
            passwordDescription05: '至少包含一个数字或特殊符号（0-9, !#$ etc）',
            passwordDescription06: '至少包含6个不重复字符',
            repeatPassword: '再次输入密码',
        },
        step3: {
            header: '激活用户',
            loadingHints: {
                '0': '正在加载用户数据',
                '1': '正在进行准备',
                '2': '新的可能性近在眼前',
                '3': '即将完成！',
            },
            successHeader: '您的账户现已准备就绪！',
            successSubheader: '您现在可以访问新的专属功能了！',
            errorHeader: '无法激活账户',
            ifWrongContact: '如果您认为出现错误，请联系支持',
            contactForHelp: '联系我们寻求帮助',
            goBack: '返回',
        },
    },
    resourcesInternal: {
        header: '资源',
        resourceTypeHeader: '类型',
        resourceNoContent: '您的学校尚未启用资源功能。',
        resourceFolderNoContent: '此文件夹中没有可用资源',
        resourceTitleHeader: '标题',
        resourcePublishDateHeader: '已发布',
        searchPlaceholder: '搜索名称或关键字...',
        cvTemplateHeader: 'HIGHERED简历模板（ATS友好型）',
        cvTemplateSubtitle: '在这里下载！',
    },
    shared: {
        userNavSection: {
            myPage: '我的页面',
            myProfile: '我的个人资料',
            myTests: '测评',
            myApplications: '申请',
            myFavorites: '收藏',
            internalResources: '资源',
            calendar: '日历',
            documents: '上传简历',
        },
        searchModule: {
            searchBar: { label: '按标题或关键字进行搜索' },
            filters: { clearFilters: '清除筛选条件' },
            filterLimit: {
                title: '已达到筛选条件限制',
                message: '此类型无法选择更多的筛选条件',
            },
        },
        postingModule: {
            postingModule: {
                positions: '职位',
                estimatedCount: '{totalCount}中约有{count}',
                knownCount: '{totalCount}中有{count}',
                noMatchFound: '无法找到任何符合您条件的内容',
            },
            postItem: { applyBefore: '申请截止日期' },
            postCard: { deadline: '截止日期' },
        },
        loginModule: {
            emailVerificationTip: '可能需要几分钟才能到达您的收件箱。',
            noEmail: '没有邮件？﻿请检查您的垃圾邮件过滤器或：',
            logIn: '登录',
            socialAuthBtns: {
                continueWithFacebook: '继续使用Facebook',
                continueWithGoogle: '继续使用谷歌',
                continueWithLinkedIn: '继续使用领英',
                continueWithWeChat: '继续使用微信',
            },
            verifyEmail: {
                verifyYourEmail: '请验证您的邮箱',
                weSentAnEmailTo: '我们已将验证发送至',
                continueToSignIn: '继续登录',
                resendEmail: '重新发送验证链接',
                newEmailSent: '新邮件已发送',
            },
            registerForm: {
                recommendation:
                    '我们建议您使用个人邮箱，不要使用\n学校邮箱，以确保您在毕业后能够继续访问您的数据\n。',
                register: '注册',
                passwordsNotMatch: '密码不一致',
            },
            logInPaper: {
                useEmail: '或使用您的邮箱',
                noAccount: '没有账户？',
                signUp: '注册',
                logInToAccess: '登录以访问此功能',
                showAllOptions: '显示所有登录选项',
                hideAllOptions: '显示更少',
            },
            logInForm: { logIn: '登录', forgotPassword: '忘记密码？' },
            forgotPassword: {
                title: '请求重新设置密码',
                description:
                    '别担心 - 每个人都会时不时忘记密码。\n请在下边输入您的邮箱，重新设置密码',
                resetPassword: '重新设置密码',
                emailSentTitle: '帮助马上就到！',
                emailHasBeenSent:
                    '已向\n <br>\n <strong>{email}</strong>\n <br>\n发送了一封邮件，其中包含如何重置密码的说明。﻿请检查您的\n收件箱。',
                noEmail: '没有邮件？',
                sendEmailOneMoreTime: '再次发送邮件',
                resendErrorTitle: '找回密码时出错',
                resendErrorMessage: '无法发送密码找回邮件。﻿可能是错误邮件？',
            },
        },
        universityBadges: {
            addAnotherUniversity: '添加其他大学',
            verificationDialog: {
                verifiedStudent: '验证{schoolAbbr}学生',
                verificationDescription: '您已是通过{email}邮件验证的{schoolAbbr}学生',
                verificationDescriptionNoEmail: '您是经过验证的{schoolAbbr}学生',
                checkYourEmail: '检查您的{schoolAbbr}邮件。',
                sentEmailDescription:
                    '我们通过{email}向您发送了有关{schoolAbbr}验证的邮件。﻿请检查您的邮件。',
                resendEmail: '再次发送邮件',
                cancelVerification: '取消验证',
                notYetVerified: '大学隶属关系尚未验证。',
                verifyYourAffiliation:
                    '如需访问{schoolAbbr}的特定功能，如专属职位发布和资源，请验证您的隶属关系。',
                verify: '验证',
                goToPlatform: '前往平台',
                verificationPending: '等待验证',
                verificationPendingDescription:
                    '{schoolAbbr}就业服务人员正在验证您的请求。﻿验证完成后，我们将通过邮件与您联系。',
            },
        },
        universityAvatar: {
            dialogs: {
                verificationDialog: {
                    verifiedStudent: '已验证的{uniSubDomain}学生',
                    verifiedStudentWithEmail: '您已是通过{email}邮件验证的{uniSubDomain}学生',
                    checkEmail: '检查您的{uniSubDomain}邮件。',
                    sentEmailInfo:
                        '我们通过{email}向您发送了有关{uniSubDomain}验证的邮件。﻿请检查您的邮件。',
                    resendEmail: '再次发送邮件',
                    cancelVerification: '取消验证',
                    notYetVerified: '大学隶属关系尚未验证。',
                    resourceAccessInfo:
                        '如需访问{uniSubDomain}的特定功能，如专属职位发布和资源，请验证您的隶属关系。',
                    verificationCancelled: '验证已取消',
                    emailSent: '邮件已发送',
                },
            },
        },
        termsAndConds: {
            termsAndConditions: '条款与﻿条件',
            privacyPolicy: '隐私政策',
            talentPanel: '学校/雇主？',
        },
        favoriteModule: {
            favoriteCard: { deleted: '已删除', deletedTitle: '此职位已不再招聘' },
        },
        pageNotFound: {
            header: '404',
            description: '看在您要找的页面已经不存在了',
            goToHome: '前往主页',
            contactus: '联系我们',
        },
        chat: {
            liveNow: '立即在线聊天！',
            seeAll: '全部',
            schoolSpecificChats: '快速访问',
            help: '需要帮助吗？',
            chatExistsLabel: '聊天已存在',
        },
        countdown: {
            day: '天',
            days: '天',
            hour: '时',
            hours: '时',
            minute: '分',
            minutes: '分',
            second: '秒',
            seconds: '秒',
        },
    },
    spotlight: {
        header: '我的个人资料',
        saveChangesToSubmit: '保存您的个人资料，是更改生效',
        saveChanges: '保存更改',
        saveSuccessful: '您的更改已成功保持',
        personalDetails: {
            header: '个人详细资料',
            firstName: '名',
            lastName: '姓',
            nationality: '国籍',
            gender: '性别',
            uploadProfileImage: '上传照片',
            genderOptions: {
                male: '男',
                female: '女',
                other: '其他',
                none: '不愿透露',
                unknown: '未知',
            },
            wrongFileTypeErrorHeader: '无效的文件类型',
            wrongFileTypeErrorDescription: '您只能上传图片',
        },
        summary: { header: '执行摘要' },
        contactDetails: {
            header: '联系人详细信息',
            contactEmail: '联系人邮箱',
            phoneNumberHeader: '移动电话号码',
            countryCode: '国家代码',
            phoneNumber: '电话号码',
            invalidEmail: '输入的邮箱不是有效邮箱',
            permanentEmail: '注意：﻿该更改永久有效。﻿您只能设置一次邮箱。',
        },
        languages: {
            header: '语言',
            languageLabel: '语言',
            levelLabel: '水平',
            addLanguage: '添加新的语言',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': '初级水平',
                '82edcac6-693b-42ea-bf24-0a52774f395c': '进行有限的工作交流',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': '专业工作交流水平',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': '专业水平',
                '250d296e-d6db-46fb-8c44-07950db80ec4': '母语或双语水平',
            },
        },
        education: {
            header: '教育',
            addEducation: '添加教育情况',
            notGraduated: '尚未毕业',
            graduatedIn: '于{date}毕业',
            dialog: {
                addNewEducation: '添加新的教育情况',
                degreeTitle: '项目',
                institution: '机构',
                degreeType: '学位',
                fieldOfStudy: '研究领域',
                cannotFindField: '无法找到我的领域',
                studyStart: '开始月份',
                studyEnd: '毕业月份',
                invalidDegreeTitle: '您需要填写项目标题。',
                invalidSchool: '您需要选择一个学校。',
                invalidStartDate: '请选择开始日期。',
                invalidEndDate: '请选择毕业日期。',
                invalidStudyPeriod: '您不能在开始日期前毕业。',
                invalidDegreeField: '请输入有效的学习领域。',
                invalidDegreeLevel: '请选择有效的学位级别。',
                selectStartDate: '开始日期',
                selectEndDate: '毕业日期',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': '学士',
                    '09f419fa-1517-41ce-970c-df0d073fc440': '硕士',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': '博士',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': '农业与﻿林业',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': '应用科学与﻿专业',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': '艺术、设计与﻿建筑',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': '商务与﻿管理',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': '计算机科学与﻿IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': '经济',
                    '5c0432d4-9297-429a-85c4-3305d207764e': '教育与﻿培训',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': '工程与﻿技术',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd': '环境研究与﻿地球科学',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': '酒店、休闲与﻿体育',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': '人文学科',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': '新闻与﻿传媒',
                    'a2744908-9521-4330-a07d-3680b058d0a6': '法律',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': '市场营销',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60': '创新与商业理学硕士',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': '发展管理硕士',
                    'a37667e2-5713-4157-82e9-78c10760d2de': '数据科学理学硕士',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': '医药与﻿健康',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': '金融学硕士',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': '国际商务研究硕士',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': '商业分析硕士',
                    '7d832109-642a-4730-aada-26927eb683ee': '管理硕士',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': '自然科学与﻿数学',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': '社会科学',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': '其他',
                },
            },
        },
        workAuthorization: {
            header: '工作授权',
            addWorkAuthorization: '添加工作收授权',
            implicitValue: '根据您的国际',
            dialog: {
                selectCountry: '选择国家',
                addEuWorkAuthorization: '添加欧盟工作授权',
            },
        },
        communication: {
            header: '沟通',
            sendMeUpdatesDescription: '请通过邮件向我发送求职新闻、职位和公司更新',
        },
        errors: { imageUpload: { title: '无法上传图片。', message: '图片过大！' } },
        exitDialog: {
            title: '未保存的更改将会丢失',
            message:
                '您正试图在未保存更改的情况下退出该页面。﻿您想在继续操作前保存您的个人资料吗？',
            stayAction: '留在本页',
            saveAction: '保存个人资料',
            continueAction: '不保存，继续',
        },
    },
    tests: {
        header: '测试',
        unauthorized: '测试目前处于封测阶段。﻿您目前没有访问这些功能的权限。﻿它们很快就能使用！',
        error: '在您加载测试时出现问题。﻿请稍后再试。',
        assessmentModule: { header: '您的测评' },
        completedYourProfile: '您需要完成个人资料才能访问本测评',
        toMyProfile: '编辑我的个人资料',
    },
    vfair: {
        header: 'EFMD虚拟活动',
        activeNow: '正在进行',
        visibilityPrivate: '保密',
        visibilityNetwork: '网络',
        visibilityOpen: '开放',
        interested: '注册',
        attend: '参加活动',
        enterEvent: '输入虚拟活动',
        notinterested: '我已经不感兴趣了',
        shownInterest: '已注册',
        signUpToday: '今天就报名吧！',
        vfairsInfo:
            '在复杂的招聘会模拟环境中，与来自全球各地的公司和组织进行联系，实现招聘者和求职者之间的实时互动。﻿点击你感兴趣的虚拟活动，注册以接收通知。',
        recruitingOrgs: '招聘公司和﻿组织',
        preRegistered: '已预先注册',
        prepareForTheFair: '为虚拟活动做准备',
        privateVFairHeader: '校园虚拟活动',
        privateVFairMessage: '此虚拟活动在EFMD学校平台上托管，因此无法从此处访问。',
        schoolNotJoinedNetworkEventMessage:
            '您的学校尚未注册参加此虚拟活动，请联系您的项目主任或求职部门，请求参与。',
        companyNotJoinedNetworkEventMessage:
            '您的组织在本次活动中没有活跃的虚拟展位。﻿请联系Highered，请求参与。',
        pavilions: '展篷',
        general: '通用',
        allCompanies: '所有公司',
        lobby: '大厅',
        inviteCode: '邀请码',
        eventRequiresInvitation: '本活动需要受到邀请才能参加',
        haveCode: '我有邀请码',
        checkCode: '检查邀请码',
        invalidCode: '无效的邀请码',
        registeredSuccessfully: '注册成功',
        pavilionTabs: {
            home: '主页',
            companies: '公司',
            articles: '文章',
            jobs: '工作',
            events: '活动',
        },
        events: {
            noEventsAvailable: '没有可选的活动',
            showCompleted: '显示已完成',
            hideCompleted: '隐藏已完成',
            liveNow: '立即上线',
            joinTheEvent: '参加活动',
            addToCalendar: '添加到日历',
        },
        links: {
            masterclasses: {
                header: '大师班',
                buttonCaption: '观看大师班课程',
                description:
                    '观看一系列顶级大师课程，包括“优化简历，获得聘用”、“让你的领英个人简介脱颖而出”﻿和“薪资谈判”等，为您职业生涯的各个阶段赋能！',
            },
            detailsmasterclass: { header: '参加大师班课程' },
            cv: {
                header: '简历模板',
                buttonCaption: '下载简历模板',
                description: '访问Highered的ATS友好型简历模板，以给招聘人员留下最佳专业印象。',
            },
            elevatorPitch: {
                header: '电梯间推荐挑战',
                buttonCaption: '发送您的推荐',
                description:
                    '参加“完美推荐挑战”！﻿这是您向数百名来自全球顶级公司、组织的招聘人员推销自己价值的机会!',
            },
        },
        footerHeaders: {
            social: '请关注我们，了解更多最新信息',
            sponsored: '赞助',
            organized: '主办',
        },
        educationPopup: {
            step00: {
                header: '分享您的教育情况',
                subtitle: '继续，让雇主了解更多关于您的情况',
                continueLabel: '添加我的教育情况',
                leaveLabel: '取消',
            },
            step01: { header: '告诉我们您的教育情况' },
            step02: { loadingLabel: '请稍等...' },
            step03: {
                header: '教育情况填写完成',
                subtitle: '现在，您可以分享自己的个人资料，让雇主对您更感兴趣',
                continueLabel: '继续探索虚拟活动',
            },
            error: {
                header: '哎呀！﻿发生错误！',
                subtitle: '我们无法存储您的教育信息。﻿请稍后再试。',
            },
        },
    },
};
